import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayOfYear from "dayjs/plugin/dayOfYear";
import { minutesToScheduleDurationValue } from "../assets/js/bookingMeetingDuration.js";
import { del, get, post } from "../assets/functions";
import router from "../router";
import store from "./index";
dayjs.extend(dayOfYear);
dayjs.extend(customParseFormat);
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

const getDefaultState = () => {
    return {
        schedule: [],
        upcoming: [],
        id: "",
        title: "",
        time: "",
        duration: "",
        meetingLink: "",
        guestMeetingLink: "",
        password: "",
        notification: [{"type": "email","time": "15","timeType": "minutes"}],
        attendees: [],
        groups: [],
        timezones: "",
        repeating: "none",
        repeatingUID: "",
        error: {},
        originalpassword: "",
        originalDateTime: "",
        datetime: "",
        custom: false,
        pastEvent: false,
        showAttendees: true,
        lastFormUpdate: null,
        checked: 'one',
        step: 0,
        userError: ""
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState());
        },
        increment(state) {
            if (state.step + 1 > 4) return;
            state.step = state.step + 1;
        },
        decrement(state) {
            if (state.step - 1 < 0) return;
            state.step = state.step - 1;
        },
        setStep(state, val) {
            state.step = val;
        },
        setUserError(state, val) {
            state.userError = val;
        },
        setNotification(state, val) {
            state.notification = val;
        },
        setError(state, val) {
            state.error = val;
        },
        setRepeating(state, val) {
            state.repeating = val;
        },
        setRepeatingUID(state, val) {
            state.repeatingUID = val;
        },
        setTimezone(state, val) {
            state.timezones = val;
            state.lastFormUpdate = Date.now();
        },
        setAttendees(state, val) {
            state.attendees = val;
            state.lastFormUpdate = Date.now();
        },
        setGroups(state, val) {
            state.groups = val;
            state.lastFormUpdate = Date.now();
        },
        setID(state, val) {
            state.id = val;
            state.meetingLink = "";
            state.guestMeetingLink = "";
        },
        setShowAttendees(state, val) {
            state.showAttendees = val;
        },
        setChecked(state, val) {
            state.checked = val;
        },
        setTitle(state, val) {
            state.title = val;
            state.lastFormUpdate = Date.now();
        },
        setPassword(state, val) {
            state.password = val;
            state.lastFormUpdate = Date.now();
        },
        setOriginalPassword(state, val) {
            state.originalpassword = val;
        },
        setOriginalDateTime(state, val) {
            state.originalDateTime = val;
        },
        setDuration(state, val) {
            state.duration = val;
            state.lastFormUpdate = Date.now();
        },
        setData(state, response) {
            state.schedule = response;
        },
        pastEvent(state, response) {
            state.pastEvent = response;
        },

        setDatetimeDate(state, val) {
            let day = dayjs(state.datetime);
            if (!day.isValid()) day = dayjs();
            day = day.dayOfYear(val.dayOfYear());
            day = day.year(val.year());
            state.datetime = day.format();
            state.lastFormUpdate = Date.now();
        },
        setDatetimeTime(state, val) {
            let day = dayjs(state.datetime);
            if (!day.isValid()) day = dayjs();
            day = day.hour(dayjs(val).hour());
            day = day.minute(dayjs(val).minute());
            state.datetime = day.format();
            state.lastFormUpdate = Date.now();
        },
        setDatetime(state, response) {
            state.datetime = response;
            state.lastFormUpdate = Date.now();
        },
        custom(state, val) {
            state.custom = val;
        },
        setMeetingLink(state, val) {
            state.meetingLink = val;
        },
        setGuestMeetingLink(state, val) {
            state.guestMeetingLink = val;
        },
    },
    actions: {
        async getScheduleInformation(context) {
            let response = await get("/api/events");
            context.commit("setData", response);
        },
        async getEventDetailsByID(context, data) {
            let response = await get("/api/event/" + data.id);
            const eventPayload = response?.event;
            const eventData = eventPayload?.dataValues || eventPayload || response;
            const timezoneValue = eventData?.timezone || eventPayload?.timezone;
            if (!eventData || typeof eventData.from === "undefined" || !timezoneValue) {
                store.commit("notifications/raw", { error: "Unable to load event details. It may have been removed." });
                return null;
            }
            let start = dayjs.unix(eventData.from).tz(timezoneValue);
            let to = dayjs.unix(eventData.to ?? eventData.from).tz(timezoneValue, true);
            if (data.end) to = dayjs.unix(data.end).tz(timezoneValue, true);
            let diff = to.diff(start, "m");
            let duration = minutesToScheduleDurationValue(diff);
            if (data.date) start = dayjs(data.date).format();
            if (data.end) to = dayjs.unix(data.end);
            let repeatType = eventData.repeatType || "none";
            let pastEvent = dayjs(start).tz(timezoneValue);
            pastEvent = pastEvent.isBefore(dayjs().tz(timezoneValue));
            context.commit("pastEvent", pastEvent);
            context.commit("setDuration", duration);
            context.commit("setDatetime", start);
            context.commit("setOriginalDateTime", start);
            context.commit("setRepeating", repeatType);
            context.commit("setShowAttendees", eventData.showAttendees);
            context.commit("setRepeatingUID", eventData.repeat);
            context.commit("setTitle", eventData.title);
            context.commit("setID", eventData.id);
            context.commit("setPassword", eventData.password);
            context.commit("setOriginalPassword", eventData.password);
            if (eventData.organizerLink) {
                context.commit("setMeetingLink", eventData.organizerLink);
            }
            if (eventData.guestLink) {
                context.commit("setGuestMeetingLink", eventData.guestLink);
            }
            context.commit("setAttendees", response.attendees || []);
            context.commit("setGroups", response.groups || []);
            context.commit("setTimezone", timezoneValue);
            context.commit("setNotification", response.notifications || []);
            return response;
        },
        async deleteEventByID(state) {
            let response = await del("/api/event/" + state.state.id);
            store.commit("notifications/raw", response);
            store.dispatch("calendar/getUpcomingEvents");
        },
        async deleteEventByUID(state) {
            let response = await del("/api/event/" + state.state.repeatingUID);
            store.commit("notifications/raw", response);
            store.dispatch("calendar/getUpcomingEvents");
        },
        async postSchedule(state) {
            let from = dayjs(state.state.datetime).tz(state.state.timezones, true);
            let body = {
                title: state.state.title || "(No Title)",
                from: from.unix(),
                duration: state.state.duration,
                repeat: state.state.repeating,
                repeatType: "all",
                showAttendees: state.state.showAttendees,
                attendees: state.state.attendees,
                groups: state.state.groups,
                password: state.state.password,
                timezone: state.state.timezones,
                notifications: state.state.notification,
            };
            let response = await post("/api/event", body);
            store.commit("notifications/raw", response);
            store.dispatch("calendar/getUpcomingEvents");
            return;
        },
        async updateEvent(state, options) {
            let from = dayjs(state.state.datetime).tz(state.state.timezones, true);
            let body = {
                id: state.state.id,
                title: state.state.title || "(No Title)",
                from: from.unix(),
                duration: state.state.duration,
                repeat: state.state.repeating,
                showAttendees: state.state.showAttendees,
                attendees: state.state.attendees,
                groups: state.state.groups,
                password: state.state.password,
                timezone: state.state.timezones,
                notifications: state.state.notification,
            };
            if (options?.allEvents) body.repeatUpdate = "all";
            if (options?.allEvents) body.repeat = state.state.repeatingUID;
            let response = await post("/api/event/update", body);
            store.commit("notifications/raw", response);
            let memoryDate = store.state.calendar.date.format("YYYY-MM-DD");
            let memoryView = store.state.calendar.view;
            let url = "/calendar/" + memoryView + "/" + memoryDate;
            if (router.currentRoute.name !== "CalendarDate") router.push(url);
            store.dispatch("calendar/getUpcomingEvents");
            return;
        },
        async fetchMeetingLink(context) {
            if (!context.state.id) return null;
            let response = await get("/api/event/link/" + context.state.id);
            if (response?.status === "ok" && response?.url) {
                context.commit("setMeetingLink", response.url);
                return response.url;
            }
            store.commit("notifications/raw", response);
            return null;
        },

    },
};
